import React from 'react';
import { NavLink } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import '../styles/Navbar.css';

const Navbar = () => {
  const { user, logout, isAdmin, isEditor } = useAuth();

  if (!user) return null;

  return (
    <nav className="navbar">
      <div className="navbar-logo">
        <h2>CartPrice</h2>
        <span className="navbar-user">{user.name}</span>
      </div>
      
      <ul className="navbar-menu">
        <li>
          <NavLink to="/" className={({ isActive }) => isActive ? 'active' : ''}>
            מחשבון עגלות
          </NavLink>
        </li>
        <li>
          <NavLink to="/parts-calculator" className={({ isActive }) => isActive ? 'active' : ''}>
            מחשבון פריטים
          </NavLink>
        </li>
        
        {isEditor() && (
          <>
            <li>
              <NavLink to="/parts" className={({ isActive }) => isActive ? 'active' : ''}>
                עריכת פריטים
              </NavLink>
            </li>
            <li>
              <NavLink to="/boms" className={({ isActive }) => isActive ? 'active' : ''}>
                ניהול BOMs
              </NavLink>
            </li>
          </>
        )}
        
        {isAdmin() && (
          <>
            <li>
              <NavLink to="/users" className={({ isActive }) => isActive ? 'active' : ''}>
                ניהול משתמשים
              </NavLink>
            </li>

            <li>
              <NavLink to="/categories" className={({ isActive }) => isActive ? 'active' : ''}>
                ניהול קטגוריות
              </NavLink>
            </li>
            <li>
              <NavLink to="/settings" className={({ isActive }) => isActive ? 'active' : ''}>
                הגדרות
              </NavLink>
            </li>
          </>
        )}
      </ul>
      
      <button className="navbar-logout" onClick={logout}>
        התנתק
      </button>
    </nav>
  );
};

export default Navbar;